const fontWeightOptions = {
  light: 'font-weight-light',
  medium: 'font-weight-medium',
  heavy: 'font-weight-heavy',
  roman: 'font-weight-roman',
  bold: 'font-weight-bold'
};

export { fontWeightOptions };
//# sourceMappingURL=fontStyleOptions.js.map
